// 活动相关
import axios from '../assets/axios'

export default {
  namespaced: true,

  state: {
    // 用户优惠券参与资格
    qualificationCoupon: {}
  },

  mutations: {
    setQualificationCoupon (state, data) {
      state.qualificationCoupon = data
    }
  },

  actions: {
    // 优惠券领取
    async drawCouponX ({ commit }, params) {
      const response = await axios.post('/coupon/v1/draw', params)
      return response.data
    },

    // 优惠券查询参与资格
    async qualificationCouponX ({ commit }, params) {
      const response = await axios.post('/coupon/v1/qualification', params)
      if (response.data.success) {
        commit('setQualificationCoupon', response.data.data)
      }
      return response.data
    },
    // 判断有没有资格
    async judgeQualificationX ({ commit }, params) {
      const response = await axios.post('/welfare/v1/queryHaveWelfare', params)
      return response.data
    },
    // 优惠券列表
    async couponListX ({ commit }, params) {
      const response = await axios.post('/coupon/v1/list', params)
      return response.data
    },
    // vip优惠券优惠券列表
    async rightsList ({ commit }, params) {
      const response = await axios.post('/coupon/v1/rights-list', params)
      return response.data
    },

    // 优惠券历史
    async couponHistoryX ({ commit }, params) {
      const response = await axios.post('/coupon/v1/list-history', params)
      return response.data
    },

    // 优惠券详情
    async couponDetailX ({ commit }, params) {
      const response = await axios.post('/coupon/v1/detail', params)
      return response.data
    },
    // 领取优惠券
    async receiveCoupon ({ commit }, params) {
      const response = await axios.post('/coupon/v1/provide', params)
      return response.data
    },

    // 使用优惠券
    async useCouponX ({ commit }, params) {
      const response = await axios.post('/coupon/v1/use', params)
      return response.data
    },

    // 使用提额券
    async useRatingX ({ commit }, params) {
      const response = await axios.post('/membership/v1/apply-limitadjust', params)
      return response.data
    },
    // 激活优惠券
    async activeCouponX ({ commit }, params) {
      const response = await axios.post('/coupon/v1/draw', params)
      return response.data
    },
    // 实名后是否已展示现金红包gif
    // async queryFirstShowGif ({ commit }, params) {
    //     const response = await axios.post('/coupon/v1/queryFirstShowGif', params)
    //     return response.data
    // },
    // 获取个人福利
    async getWelfareListX ({ commit }, params) {
      const response = await axios.post('/coupon/v1/queryCouponWelfare')
      return response.data
    },
    // 获取历史福利
    async getWelfareHistoryListX ({ commit }, params) {
      const response = await axios.post('/coupon/v1/queryCouponWelfareHistory')
      return response.data
    },
    // 保存活动转盘数据
    async saveCouponPreShow (store, params) {
      const response = await axios.post('/coupon/v1/couponPreShow', params)
      return response.data
    },
    // 优惠券使用检查
    async useCheck (store, params) {
      const response = await axios.post('/coupon/v1/useCheck', params)
      return response.data
    },
    // 活动详情
    async getActivityDetail (store, params) {
      const response = await axios.post('/active/v1/detail', params)
      return response.data
    },
    async receiveActive (store, params) {
      const response = await axios.post('/active/v1/receive', params)
      return response.data
    }
  }
}
